/**
 * @module app.shared.lib.screen
 * Includes types and functions for computing screen positioning.
 */

export type Rect = { top: number, right: number, bottom: number, left: number };
export type Coords = { x: number, y: number };

/**
 * @function getQuadrantCoordinates
 * Given a Rect or Coords or both, it will find the corner closest to the
 * center of the screen relative to a top-left origin. Useful for computing
 * the absolute, screen-relative position of a floating element.
 * @param rect The DOMRect-like object for which to compute the closest corner
 * to the center of the screen.
 */
export function getQuadrantCoordinates(rect: Coords & Partial<Rect>): Partial<Rect> {
    let top, right, bottom, left;
    const { clientWidth: width, clientHeight: height } = document.body;
    if(rect.x > width / 2) {
        right = width - (rect.left || rect.x);
    } else {
        left = rect.right || rect.x;
    }
    if(rect.y > height / 2) {
        bottom = height - (rect.top || rect.y);
    } else {
        top = rect.bottom || rect.y;
    }
    return { top, right, bottom, left };
}
